import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { horizontalLoop } from "./gsapHorizontalLoop";

// Swiper
import Swiper from 'swiper';
import { Autoplay, EffectCreative, EffectFade, Pagination, Navigation } from 'swiper/modules';

// GSAP Configuration
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.gsapHorizontalLoop = horizontalLoop;
window.gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// Swiper
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-creative';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
window.Swiper = Swiper;
Swiper.use([Autoplay, EffectCreative, EffectFade, Pagination, Navigation]);

// Components
// import parallaxModule from './parallax.js';

// Modules
// parallaxModule();

// Global
window.Alpine = Alpine;

// Inits
Alpine.plugin(collapse);
Alpine.start();